export class Rebombeo{
    abastecedoraId: string;
    cantidad: number;
    aforadorInicial: number;
    aforadorFinal: number;
    fechaHora: Date;
}